<template>
    <div>
        <transition name="slide">
            <b-card :header="captionFiles">
                <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                    <b-table
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive="sm"
                        :items="filesArray"
                        :fields="fieldsAttachments"
                        :current-page="currentPage"
                        :per-page="perPage"
                    >
                        <template slot="link" slot-scope="data">
                            <a v-bind:href="data.item.url">See</a>
                        </template>
                        <template slot="title" slot-scope="data">
                            <strong>{{data.item.title}}</strong>
                        </template>
                        <template slot="description" slot-scope="data">
                            <strong>{{data.item.description}}</strong>
                        </template>
                        <template slot="viewButton" slot-scope="data">
                            <b-button :value="data.item" v-on:click="rowClickedRemove(data.item)" block variant="danger"><i class="fa fa-ban"></i>Remove</b-button>
                        </template>
                    </b-table>
                </b-form-checkbox-group>
                <nav>
                    <b-pagination
                        size="sm"
                        :total-rows="filesArray.length"
                        :per-page="perPage"
                        v-model="currentPage"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    />
                    <b-row class="align-items-center">
                        <b-col cols="6" class="mb-3 mb-xl-0">
                            <b-button v-on:click="addFileButton" block variant="primary">Add File</b-button>
                        </b-col>
                        <b-col cols="6" class="mb-3 mb-xl-0">
                            <b-button
                                v-if="filesSelected.length > 0"
                                v-on:click="removeMembersButton"
                                block
                                variant="danger"
                            >Remove Attachment(s)</b-button>
                        </b-col>
                    </b-row>
                </nav>
            </b-card>
        </transition>
        <b-modal title="Add an file" class="modal-primary" v-model="fileModal" @ok="addFile">
            <b-form-group v-if="attachmentData.fileFile != null">
                <b-form-input
                    id="fileTitle"
                    type="text"
                    autocomplete="name"
                    v-model="attachmentData.title"
                    size="md"
                    placeholder="Enter file title..."
                ></b-form-input>
            </b-form-group>
            <b-form-group v-if="attachmentData.fileFile != null">
                <b-form-textarea
                    id="fileDescription"
                    v-model="attachmentData.description"
                    placeholder="Enter file description..."
                    :rows="3"
                    :max-rows="6"
                    size="sm"
                ></b-form-textarea>
            </b-form-group>
            <b-form-group
                label="Upload file"
                label-for="fileInput"
                :label-cols="3"
                :horizontal="true"
            >
                <b-form-file
                    accept="application/pdf"
                    id="fileInput"
                    :plain="true"
                    v-model="attachmentData.fileFile"
                ></b-form-file>
            </b-form-group>
            <b-form-group v-if="attachmentData.fileFile != null">
                <b-img v-bind:src="getfileFile()" fluid alt="Responsive file"/>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { storage } from '@/config/devowqlo';
export default {
    name: "fileAttachment",
    props: {
        type: {
            type: String,
            default: ""
        },
        typeId: {
            type: String,
            default: ""
        },
        teamId: {
            type: String,
            default: ""
        },
        captionFiles: {
            type: String,
            default: "Files"
        },
        hover: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isEdit: false,
            currentTeam: null,
            attachmentData: {
                title: null,
                type: null,
                description: null,
                url: null,
                thumbUrl: null,
                fileFile: null
            },
            center: null,
            marker: null,
            teamsArray: [],
            teamsNamesArray: [],
            filesArray: [],
            filesSelected: [],
            fileModal: false,
            previewImage: null,
            previewImageUrl: null,
            fieldsAttachments: [
                // { key: "checkbox", label: "" },
                { key: "link" },
                { key: "title" },
                { key: "description" },
                { key: "viewButton", label: "Actions" }
            ],
            currentPage: 1,
            perPage: 5,
            totalRows: 0,
            KEY_TYPE_ATTACHMENT:  this.getKeyAttachment(),
            ST_TYPE_ATTACHMENT: this.getStAttachment(),
        };
    },
    created() {
        this.getFiles()
        console.log("type: ", this.type);
        console.log("typeId: ", this.typeId);
        console.log("teamId: ", this.teamId);
        console.log("teamId: ", this.KEY_TYPE_ATTACHMENT);
    },
    methods: {
        addFileButton() {
            this.fileModal = true;
        },
        addFile() {
            const dateNow = Date.now();
            console.log("Uploading file...");
            const fileName =
                +new Date() + "-" + this.attachmentData.fileFile.name;
            const fileMetadata = {
                contentType: this.attachmentData.fileFile.type
            };
            // 1. Save Image on Storage
            const uploadTask = storage
                .ref()
                .child(this.ST_TYPE_ATTACHMENT)
                .child("Files")
                .child(fileName)
                .put(this.attachmentData.fileFile, fileMetadata)
                .then(snapshot => snapshot.ref.getDownloadURL())
                .then(url => {
                    const thumbImageUrl = "thumb_" + fileName;
                   
                   // 2. save on Database
                    var fileModel = {
                        title: this.attachmentData.title,
                        description: this.attachmentData.description,
                        type: "file",
                        url: fileName,
                        thumbUrl: thumbImageUrl,
                        created: dateNow
                    };
                    db.ref(this.KEY_TYPE_ATTACHMENT)
                        .child(this.teamId)
                        .child(this.typeId)
                        .child("files")
                        .push(fileModel);
                });
        },
        getfileFile() {
            console.log(this.attachmentData.fileFile);
            var reader = new FileReader();
            reader.onload = e => {
                this.previewImage = e.target.result;
            };
            reader.readAsDataURL(this.attachmentData.fileFile);
            return this.previewImage;
        }
        ,getFiles (){
            db.ref(this.KEY_TYPE_ATTACHMENT)
                .child(this.teamId)
                .child(this.typeId)
                .child("files")
                .on('value', (snapshot) =>{

                this.filesArray = []
                console.log(snapshot.val())
                snapshot.forEach(childSnapshot => {
                    console.log(childSnapshot)
                    var fileObject = childSnapshot.val()
                    fileObject.key = childSnapshot.key

                    storage.ref().child(this.ST_TYPE_ATTACHMENT).child('Files').child(fileObject.url).getDownloadURL().then((url) => {

                        fileObject.url = url;
                        this.filesArray.push(fileObject)

                    }).catch(function(error) {
                        // Handle any errors
                    });
                 
                })
            })
        },
        rowClickedRemove(data){
            db.ref(this.KEY_TYPE_ATTACHMENT)
                .child(this.teamId)
                .child(this.typeId)
                .child("files")
                .set(null)
        }, 
        // Aux functions
        getKeyAttachment(){
            if (this.type == "training") {
                return "trainingAttachments"
            } else if (this.type == "match"){
                return "matchAttachments"
            }
        },
        getStAttachment(){
            if (this.type == "training") {
                return "TrainingAttachments"
            } else if (this.type == "match"){
                return "MatchAttachments"
            }
        }
    }
};
</script>

<style scoped>
</style>